import { render, staticRenderFns } from "./ModalProposalHistory.vue?vue&type=template&id=fa30dde4&scoped=true"
import script from "./ModalProposalHistory.vue?vue&type=script&lang=js"
export * from "./ModalProposalHistory.vue?vue&type=script&lang=js"
import style0 from "./ModalProposalHistory.vue?vue&type=style&index=0&id=fa30dde4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa30dde4",
  null
  
)

export default component.exports